<div class="alert" [ngClass]="getAlertStatus()">
  <span class="mark"></span>
  <span class="error-text">{{ errorText | translate }}</span>
  <span *ngIf="!cannotClose" class="cancel-mark" (click)="closeBar()"></span>
</div>
